<template>
  <div :id="id" :class="['result-type-'+fields.type_id, 'result-faq']"
       class="result result-faq">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        {{lang}}
        <div class="result-content">
          <div class="ce-accordion">
            <div class="panel panel-accordion">
              <div class="panel-heading"  >
                <a class="result-title" v-html="fields.title" data-toggle @click="toggle()"></a>
                <div class="result-locale-info alert alert-info" v-if="!isLanguageAvailable()">
                  <i class="glyphicon glyphicon-info-sign"></i>
                  {{$t("service_download.result.lang_not_available",resultLanguage)}}
                </div>
              </div>
              <div ref="toggleContainer" class="panel-collapse collapse">
                <div class="result-description" v-html="fields.description"></div>
                <div class="taglist mb-xs">
                  <ul>
                    <li v-for="(ids,category) in faqCategories" class="badge"
                        @click="setFilter('categories',ids)">
                      {{category}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="result-actions pull-right">
          <div class="faq-share result-action hidden">
            <a href="#">Share me</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const FALLBACK_LANGUAGE = 'en';

export default {
  name: "FaqResultEntry",
  props: ['result','lang'],
  data: function () {
    return {
      fields: null,
      id: null,
      expanded: false,
    }
  },
  computed: {
    date() {
      if (typeof this.fields._date_ == 'number') {
        return new Date(this.fields._date_ * 1000);
      } else {
        if (typeof this.fields._date_ == 'string') {
          return new Date(parseInt(this.fields._date_) * 1000);
        }
      }
      return this.fields._date_;
    },
    existing_languages() {
      return Array.from(this.fields.existing_languages).sort();
    },
    resultLanguage(){
        return this.$store.state.selections.resultLanguage;
    },
    faqCategories() {
      let filter = this.$options.filters.category;
      let cat = {};

      let cat_id = [].concat(this.fields.level_0, this.fields.level_1, this.fields.level_2, this.fields.level_3, this.fields.level_4).filter((i) => i);
      for (let i = 0; i < cat_id.length; i++) {
        let name = filter(cat_id[i]);

        if (!name)
          continue;

        if (!cat[name]) {
          cat[name] = [];
        }

        cat[name].push(cat_id[i]);
      }
      return cat;
    }
  },
  methods: {
    mapFields() {

    },
    isLanguageAvailable(){
      if(this.resultLanguage === null)
        return true;

      return !!this.result.languages[this.resultLanguage];
    },
    toggle() {
      let target = this.$refs['toggleContainer']

      if (!target)
        return;

      if (this.expanded) {
        $(target).collapse('toggle');
      } else {
        $(target).collapse('toggle');
      }
    }
  }
  ,
  watch: {
    result() {
      this.id = this.result.id;
      this.fields = this.result.fields;
    }
  }
  ,
  created: function () {
    this.id = this.result.id;
    this.fields = this.result.fields;

  }
}

let a = '\n<div class="ng-phone-search">\n    <div class="row">\n        <form name="searchform" class="searchform" ng-submit="showResults()">\n            <div class="query col-sm-12">\n                <input class="typeahead" type="text"  id="query" name="query" ng-model="query" placeholder="">\n                <button type="submit">Suchen</button>\n            </div>\n        </form>\n    </div>\n    <div class="row">\n        \n        <div class="results col-sm-12">\n            <div class="result-heading row">\n                <div class="col-sm-4">\n                    <div class="displayname">Name, Vorname</div>\n                    <div class="department">Abteilung</div>\n                    <div class="location">Ort</div>\n                </div>\n                <div class="col-sm-4">Telefon</div>\n                <div class="col-sm-4">Fax</div>\n            </div>\n            <div class="result row" ng-repeat="(key,data) in results track by data.id">\n                    <div class="col-sm-4">\n                        <span class="displayname" ng-bind-html="data.displayname"></span>\n                        <span class="department" ng-bind-html="data.department"></span>\n                        <span class="title" ng-bind-html="data.title"></span>\n                        <span class="location" ng-bind-html="data.l"></span>\n                    </div>\n                    <div class="col-sm-4 numbers phone-numbers">\n                        <ul>\n                            <li ng-repeat="number in getPhoneNumbers(data) track by $index"><span class="number-{{getNumberType(number)}} number" ng-bind-html="number|phone"></li>\n                        </ul>\n                    </div>\n                    <div class="col-sm-4 numbers fax-numbers">\n                        <ul>\n                            <li ng-repeat="number in getFaxNumbers(data) track by $index"><span class="number-{{getNumberType(number)}} number" ng-bind-html="number|phone"></li>\n                        </ul>\n                    </div>\n            </div>\n        </div>\n    </div>\n</div>';
</script>

<style lang="less" scoped>
.result-video {
  border-bottom: 1px solid #cfd2d1 !important;
  height: 100%;
  padding-bottom: 20px !important;
}

.result-actions {
  margin-top: -70px;
}

.result-thumbnail {
  height: auto;
  padding-bottom: 25px;

  img {
    position: absolute;
    left: 0;
    top: 0;
    min-width: 100%;
    height: auto;
    max-height: unset;
  }

  figure {
    position: relative;

    &:after {
      content: '';
      display: block;
      width: 100%;
      padding-top: 56%;
    }
  }
}
</style>
